import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout } from 'antd';
import { withTranslation } from 'react-i18next';
import HeaderPage from '../../components/Guest/Header/headerMain';
import HomeThemeOne from '../Home/HomeThemeOne';
import HomeThemeTwo from '../Home/HomeThemeTwo';
import FooterMenu from '../../components/Guest/Footer/Footer';
import * as SignalR from '@aspnet/signalr';

const { Content } = Layout;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
    'templateStore',
    'translationStore',
    'loginStore',
    'authStore'
)
@observer
class MasterHomePage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.templateStore.getActive();

        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        }

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    render() {
        const history = this.props.history;
        const { activeTemplate } = this.props.templateStore;

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            {
                                activeTemplate.templateSetting.theme === 1
                                    ?
                                    <>
                                        <Layout className='stm-layout-master'>
                                            <Content>
                                                <HeaderPage history={history} />

                                                <HomeThemeOne history={history} />

                                                <FooterMenu history={history} menuText={'home'} />
                                            </Content>
                                        </Layout>
                                    </>
                                    :
                                    <>
                                        <HomeThemeTwo history={history} />
                                    </>
                            }

                        </>
                        :
                        null
                }
            </>

        )
    }
}

export default withTranslation()(MasterHomePage)